import i18nhelper from './locale-seed'
import { bus } from './bus'
// if (location.href.includes('localhost')) {
//   import("./locale-seed")
// }

import "./gh"

const addSingForPeace = (_) => {
  var topnavbar = document.querySelector('.navbar-start')
  if(!topnavbar) return

  var events = _.last(topnavbar.childNodes)
  if(!events) return

  var ddown = events.querySelector('.navbar-dropdown')
  if(!ddown) return

  if(ddown.querySelector('.fa.fa-star') || ddown.childNodes.length >= 3) return

  var newnode = ddown.children[0].cloneNode()
  newnode.textContent = ''
  newnode.href = '/events/5'

  var txtspan = document.createElement('span')
  txtspan.textContent = 'Sing for Peace'
  newnode.appendChild(txtspan)

  var icon = document.createElement('i')
  icon.classList.add('fa', 'fa-star', 'has-text-warning', 'ml-1')
  newnode.appendChild(icon)
  ddown.insertBefore(newnode, ddown.children[0])
}

const init = (context = {}) => {
  const { m, _ } = context
  console.log("sidekick init");
  i18nhelper(context)

  if(location.host === 'easyvirtualchoir.com') {
    setInterval(() => addSingForPeace(_), 100)
  }
}

export default { init, bus };
